import { useContext } from 'react';
import { ThemeContext } from './index';
export const useTokens = () => {
    const theme = useContext(ThemeContext);
    if (!theme) {
        throw new Error('Theme has not been set on context');
    }
    return theme.tokens;
};
//# sourceMappingURL=use-tokens.js.map